export const sectionGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

export const sectionHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
  userSelect: 'none',
};

export const sectionHeaderLeftStyles = {
  display: 'flex',
  alignItems: 'baseline',
  gap: '6px',
};

export const sectionTitleStyles = {
  color: 'text.primary',
};

export const sectionMetaStyles = {
  color: 'text.secondary',
};

export const cardsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

export const getExpandIconStyles = isExpanded => ({
  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.2s ease',
});
